angular.module('pdf').factory('dataPrep', [
  '$q', 'BrandingSettings', 'SITE_URL',
  function ($q, BrandingSettings, SITE_URL) {
    const dataPrep = {
      composeAddress: (city, state, zip) => {
        let result = city;
        if (result && (state || zip)) result += ', ';
        return result + `${state} ${zip}`.trim();
      },

      formatPhone: (str) => {
        if (!str || str.match(/[^\d]/) || str.length != 10) return str;
        return `(${str.slice(0, 3)}) ${str.slice(3, 6)}-${str.slice(6)}`;
      },

      createPracticeData: (blockTitle, provider, practice, address) => {
        return {
          blockTitle,
          doctorName: `${provider.first_name || ''} ${provider.last_name || ''}`,
          practiceName: (practice || {}).name || '',
          phone: dataPrep.formatPhone(address.phone || ''),
          addressStreet: address.street_line_1 || '',
          addressCity: dataPrep.composeAddress((address.city || ''), (address.state || ''), (address.zip || '')),
          public_id: practice.public_id,
          ...(address.website && { website: address.website })
        };
      },

      /**
       * Load branding for given practice, calculate logoUrl and save back into practice object
       * @returns a promise
       */
      loadCoBranding: (practice) => {
        const pid = practice.public_id;
        if (pid) {
          return BrandingSettings.get({ pid }).$promise
            .then((branding) => {
              const filename = branding?.main_logo_filename;
              practice.logoUrl = filename ? `brandings/img/${filename}` : undefined;
            })
            .catch((error) => {
              console.error('Error fetching branding settings:', error);
              return $q.reject();
            });
        } else {
          return $q.resolve();
        }
      },

      prepareData: (referral) => {
        var patient = referral.patient || {};
        const { first_name = '', last_name = '', birthday = '', email = '', phone } = patient;
        const patientData = {
          name: `${first_name} ${last_name}`,
          birthday: birthday || '',
          email: email || '',
          phone: phone ? dataPrep.formatPhone(phone) : ''
        };

        const { procedure = {}, teeth } = referral;
        const procedureData = {
          name: procedure.name || '',
          practiceType: procedure.practice_type?.name || ''
        };

        if (teeth && teeth.length > 0) {
          procedureData.teeth = teeth;
        }

        const originalPracticeData = dataPrep.createPracticeData('Referred by:', referral.orig_provider || {}, referral.orig_provider.practice || {}, referral.orig_provider_address || (referral.orig_provider.addresses.length && referral.orig_provider.addresses || [{}])[0]);
        const destinationPracticeData = dataPrep.createPracticeData('Referred to:', referral.dest_provider || {}, referral.dest_practice || {}, referral.address || {});

        const referralDate = referral.created_at;
        const notes = referral.notes;
        const attachments = referral.attachments.map(attachment => ({ metadata: attachment }));

        return {
          patientData,
          procedureData,
          originalPracticeData,
          destinationPracticeData,
          referralDate,
          notes,
          attachments
        };
      }
    };

    return dataPrep;
  }
]);